
export default function StatsSection() {
  const stats = [
    {
      icon: 'ri-checkbox-circle-line',
      value: '50+',
      label: 'Hizmetlerimiz',
      color: 'from-blue-500 to-cyan-500',
    },
    {
      icon: 'ri-customer-service-2-line',
      value: '7/24',
      label: 'Kesintisiz Destek',
      color: 'from-cyan-500 to-blue-500',
    },
    {
      icon: 'ri-award-line',
      value: '10+',
      label: 'Sektör Tecrübesi',
      color: 'from-blue-500 to-cyan-500',
    },
  ];

  return (
    <section className="relative py-20 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="group relative p-8 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 hover:border-blue-500/50 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-blue-500/20"
            >
              {/* Glow Effect */}
              <div className={`absolute inset-0 bg-gradient-to-br ${stat.color} opacity-0 group-hover:opacity-10 rounded-2xl transition-opacity duration-300`}></div>

              {/* Content */}
              <div className="relative z-10 text-center">
                <div className={`inline-flex items-center justify-center w-16 h-16 mb-4 bg-gradient-to-br ${stat.color} rounded-xl`}>
                  <i className={`${stat.icon} text-3xl text-white`}></i>
                </div>
                <div className={`text-5xl font-bold mb-2 bg-gradient-to-r ${stat.color} bg-clip-text text-transparent`}>
                  {stat.value}
                </div>
                <div className="text-gray-300 font-medium">{stat.label}</div>
              </div>

              {/* Corner Accent */}
              <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-blue-500/20 to-transparent rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}